import * as React from "react";
import Icon from "common/icons";

const styles = require("./noData.scss");

interface IProps {
  message: React.ReactNode;
}

const NoData = ({ message }: IProps) => {
  return (
    <div className={styles.wrapper}>
      <Icon icon="INTERESTS_NO_DATA" />
      <div className={styles.text}>{message}</div>
    </div>
  );
};

export default NoData;
